import React from 'react';
import AuthService from './authService.js';
import SurveyItemList from '../Domain/SurveyItemList';
import serviceHelper from '../Helpers/serviceHelper.js';
import ProjectSurveyItem from '../Domain/ProjectSurveyItem.js';
import SearchParams from '../Elements/SearchParams';
import ProjectSurveySearchParams from '../Contents/Operations/Projects/ProjectSurveySearchParams';

class SurveyService extends React.Component {
  static GetSurveyList(
    surveyId,
    clientIdFilter,
    projectIdFilter,
    opportunityIdFilter,
    surveyIdFilter,
    tpProjectIdFilter,
    tpSurveyIdFilter
  ) {
    const searchItem = {
      ClientId: clientIdFilter,
      ProjectId: projectIdFilter,
      OpportunityId: opportunityIdFilter,
      SurveyId: surveyIdFilter,
      TpProjectId: tpProjectIdFilter,
      TpSurveyId: tpSurveyIdFilter,
    };

    let url = '/api/Survey';

    if (surveyId != null && surveyId !== -1) {
      url += `/GetSurveyById/${surveyId}?clearCache=true`;
    } else {
      url += `?searchItem=${JSON.stringify(searchItem)}&clearCache=true`;
    }
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static getSurveyBySassieId(surveyId) {
    if (!surveyId) return '';
    const authService = AuthService.getInstance();
    const url = `/api/Survey/GetSurveyBySassieId/${surveyId}?clearCache=false`;
    return authService.CallBackendFunction(url);
  }

  static async GetSurveyListByClientId(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };

    const url = `/api/Survey/GetAllSurveyAsync?searchParams=${JSON.stringify(searchParams)}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async UpdateSurvey(item) {
    item = serviceHelper.ConvertAllPropertyToString(item);
    const JSONItem = JSON.stringify(item);
    return AuthService.getInstance().CallBackendFunctionPost('/api/Survey/UpdateSurveyAsync', JSONItem);
  }

  static EditSurvey(item) {
    const JSONItem = JSON.stringify(item);

    return AuthService.getInstance().CallBackendFunctionPost('/api/Survey/PostSurveyAsync', JSONItem);
  }

  static RemoveSurvey(SurveyId) {
    const url = `/api/Survey/RemoveSurvey/${SurveyId}`;
    return AuthService.getInstance().CallBackendFunctionDelete(url);
  }

  static GetAvailableSurveyFromAppolo(clientId) {
    return AuthService.getInstance().CallBackendFunction(`/api/Survey/GetAvailableSurveyFromAppolo/${clientId}`);
  }

  static GetAvailableSurveys(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, ProjectSurveySearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/Survey/GetAvailableSurveysAsync?searchParams=${searchParams.serializeForBackendCall()}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new SurveyItemList(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static ConvertProjectSurveyDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ProjectSurveyItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static RemoveProjectSurvey(item) {
    const JSONItem = JSON.stringify(item);
    return AuthService.getInstance().CallBackendFunctionPut('/api/Survey/RemoveProjectSurvey', JSONItem);
  }

  static AssociateProjectSurvey(item) {
    const JSONItem = JSON.stringify(item);
    return AuthService.getInstance().CallBackendFunctionPut('/api/Survey/AssociateProjectSurvey', JSONItem);
  }

  static GetProjectSurveyList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, ProjectSurveySearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/Survey/GetAllProjectSurveyAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }
}

export default SurveyService;
